module.exports = __webpack_public_path__ + "static/barbara-a097ee7b6f877a70d900123d3585945d.png";